import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/devices/devices.scss";
import { Button, FormControl } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import DeviceTable from "./deviceTable";
import { encodeQueryData } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import queryString from "query-string";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import RoleAccessBadge from "../common/roleAccessBadge";

class Devices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceList: [],
      searchText: "",
      deviceTypeFilter: "all",
      deviceTypeCounts: [],
      networkTypeFilter: "4G",
      networkTypeCounts: [],
      sortKey: "customerName",
      sortDirection: "asc",
      pageNumber: 1,
      pageSize: 100,
      totalItems: 0,
      totalPages: 1,
    };
    this.customerId = "";
    this.searchTimer = null;
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.customerId = values.customerId || "";
    this.getDevices();
    this.getDeviceTypeCounts();
    this.getNetworkTypeCounts();
  }

  getDevices = async () => {
    const query = encodeQueryData(this.setDeviceQueryObject());
    const url = `${apiHost}/api/Device/AllDevice?${query}`;

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const pagination = response.headers.pagination
        ? JSON.parse(response.headers.pagination)
        : {};

      this.setState({
        deviceList: response.data || [],
        totalItems: pagination.totalItems || 0,
        totalPages: pagination.totalPages || 1,
        pageNumber: pagination.currentPage || this.state.pageNumber,
      });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  setDeviceQueryObject = () => {
    let data = {};
    data.customerId = this.customerId;
    data.SearchString = this.state.searchText;
    data.DeviceType = this.state.deviceTypeFilter;
    data.NetworkType = this.state.networkTypeFilter;
    data.PageSize = this.state.pageSize;
    data.PageNumber = this.state.pageNumber;
    data.SortDirection = this.state.sortDirection === "desc" ? "des" : "asc";
    data.SortString = this.getApiSortString(this.state.sortKey);
    return data;
  };

  handleSearch = (searchText) => {
    this.setState({ searchText, pageNumber: 1 }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getDevices();
        this.getDeviceTypeCounts();
        this.getNetworkTypeCounts();
      }, 300);
    });
  };

  handleDeviceTypeFilter = (deviceTypeFilter) => {
    this.setState({ deviceTypeFilter, pageNumber: 1 }, () => {
      this.getDevices();
      this.getNetworkTypeCounts();
    });
  };

  handleNetworkTypeFilter = (networkTypeFilter) => {
    this.setState({ networkTypeFilter, pageNumber: 1 }, () => {
      this.getDevices();
      this.getDeviceTypeCounts();
    });
  };

  handleSort = (sortKey) => {
    this.setState((prevState) => ({
      sortKey,
      sortDirection:
        prevState.sortKey === sortKey && prevState.sortDirection === "asc"
          ? "desc"
          : "asc",
      pageNumber: 1,
    }), () => this.getDevices());
  };

  handlePageSize = (pageSize) => {
    this.setState({ pageSize: parseInt(pageSize), pageNumber: 1 }, () => this.getDevices());
  };

  handlePageChange = (pageNumber) => {
    const nextPage = Math.max(1, Math.min(pageNumber, this.state.totalPages || 1));
    this.setState({ pageNumber: nextPage }, () => this.getDevices());
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-devices?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/create-new-devices`);
    }
  };

  handleSyncMeiTrak = async () => {
    this.props.setLoadingPageAction(true);
    try {
      await axios.get(`${apiHost}/api/Device/SyncFromMeiTrak`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      await this.getDevices();
      await this.getDeviceTypeCounts();
      await this.getNetworkTypeCounts();
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(e.response?.data?.statusResponse || `${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  getDeviceTypeCounts = async () => {
    const query = encodeQueryData({
      customerId: this.customerId,
      SearchString: this.state.searchText,
      NetworkType: this.state.networkTypeFilter,
    });
    const url = `${apiHost}/api/Device/DeviceTypeCounts?${query}`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ deviceTypeCounts: response.data || [] });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  getNetworkTypeCounts = async () => {
    const query = encodeQueryData({
      customerId: this.customerId,
      SearchString: this.state.searchText,
      DeviceType: this.state.deviceTypeFilter,
    });
    const url = `${apiHost}/api/Device/DeviceNetworkTypeCounts?${query}`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ networkTypeCounts: response.data || [] });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
  };

  getApiSortString = (sortKey) => {
    const sortMap = {
      assetName: "asset",
      customerName: "customer",
      deviceStatus: "status",
      lastMessageTime: "lastconnected",
      dbUpdated: "updated",
      dbCreated: "created",
      imei: "imei",
      simNumber: "sim",
      networkType: "network",
    };

    return sortMap[sortKey] || sortKey || (this.customerId ? "name" : "customer");
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const {
      searchText,
      deviceTypeFilter,
      deviceTypeCounts,
      networkTypeFilter,
      networkTypeCounts,
      sortKey,
      sortDirection,
      pageNumber,
      pageSize,
      totalItems,
      totalPages,
      deviceList,
    } = this.state;
    const entryStart = totalItems === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
    const entryEnd = Math.min(pageNumber * pageSize, totalItems);
    const pageSizes = [50, 100, 200];
    const allDeviceTypeCount = deviceTypeCounts.reduce((total, item) => total + item.count, 0);
    const allNetworkTypeCount = networkTypeCounts.reduce((total, item) => total + item.count, 0);
    const deviceTypeFilters = [
      { key: "all", label: "All", count: allDeviceTypeCount },
      ...deviceTypeCounts.map((item) => ({
        key: item.type,
        label: item.type,
        count: item.count,
      })),
    ];
    const networkTypeFilters = [
      { key: "all", label: "All", count: allNetworkTypeCount },
      ...networkTypeCounts.map((item) => ({
        key: item.type,
        label: item.type,
        count: item.count,
      })),
    ];
    const hasDefaultNetworkFilter = networkTypeFilters.some(
      (filter) => filter.key.toLowerCase() === "4g"
    );
    if (!hasDefaultNetworkFilter) {
      networkTypeFilters.splice(1, 0, { key: "4G", label: "4G", count: 0 });
    }

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Devices</title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper device-page">
              <div className="device-page-header">
                <div>
                  <h2>Devices</h2>
                  <p>Manage tracker hardware, assigned assets, SIM details and connection status.</p>
                  {values.customerId && (
                    <a
                      className="device-filter-pill"
                      onClick={() => localStorage.removeItem("customer")}
                      href="/devices"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </a>
                  )}
                </div>
                <div className="device-header-actions">
                  <RoleAccessBadge role="SystemAdmin" />
                  <Button
                    className="device-sync-button"
                    variant="secondary"
                    onClick={() => this.handleSyncMeiTrak()}
                  >
                    <i className="fa fa-refresh"></i>
                    Sync from MeiTrak
                  </Button>
                  <Button
                    className="device-create-button"
                    variant="primary"
                    onClick={() => this.handleCreateNew()}
                  >
                    <i className="fa fa-plus"></i>
                    Create new
                  </Button>
                </div>
              </div>

              <div className="device-toolbar">
                <div className="device-toolbar-top">
                  <div className="device-search">
                    <i className="fa fa-search"></i>
                    <FormControl
                      aria-label="Search devices"
                      onChange={(e) => this.handleSearch(e.target.value)}
                      placeholder="Search devices, customers, assets, IMEI, SIM or status"
                      value={searchText}
                    />
                    {searchText && (
                      <button onClick={() => this.handleSearch("")} type="button">
                        <i className="fa fa-times"></i>
                      </button>
                    )}
                  </div>
                  <div className="device-type-filter" aria-label="Device network filter">
                    <span>Network</span>
                    <div>
                      {networkTypeFilters.map((filter) => (
                        <button
                          className={networkTypeFilter.toLowerCase() === filter.key.toLowerCase() ? "active" : ""}
                          key={filter.key}
                          onClick={() => this.handleNetworkTypeFilter(filter.key)}
                          type="button"
                        >
                          {filter.label}
                          <strong>{filter.count}</strong>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="device-type-filter-row">
                  <div className="device-type-filter" aria-label="Device type filter">
                    <span>Type/Model filter</span>
                    <div>
                      {deviceTypeFilters.map((filter) => (
                        <button
                          className={deviceTypeFilter.toLowerCase() === filter.key.toLowerCase() ? "active" : ""}
                          key={filter.key}
                          onClick={() => this.handleDeviceTypeFilter(filter.key)}
                          type="button"
                        >
                          {filter.label}
                          <strong>{filter.count}</strong>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="device-table-shell">
                <DeviceTable
                  deviceList={deviceList}
                  onSort={this.handleSort}
                  sortDirection={sortDirection}
                  sortKey={sortKey}
                />
              </div>
              <div className="device-pagination">
                <div>
                  Showing <strong>{entryStart}</strong> to <strong>{entryEnd}</strong> of{" "}
                  <strong>{totalItems}</strong> devices
                </div>
                <div className="device-pagination-actions">
                  <label>
                    Rows
                    <select value={pageSize} onChange={(e) => this.handlePageSize(e.target.value)}>
                      {pageSizes.map((size) => (
                        <option key={size} value={size}>{size}</option>
                      ))}
                    </select>
                  </label>
                  <button
                    disabled={pageNumber <= 1}
                    onClick={() => this.handlePageChange(pageNumber - 1)}
                    type="button"
                  >
                    Previous
                  </button>
                  <span>
                    Page <strong>{pageNumber}</strong> of <strong>{totalPages}</strong>
                  </span>
                  <button
                    disabled={pageNumber >= totalPages}
                    onClick={() => this.handlePageChange(pageNumber + 1)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Devices);
